<script setup lang="ts">
import type { SelectGroupOption } from 'naive-ui'
import type { ProjectOption } from './project-option.type'
import { copyFeatureNotSupportedHint } from '~/constants'

const props = defineProps({
  option: {
    type: Object as PropType<ProjectOption | SelectGroupOption>,
    required: true,
  },
})

const clipboardStore = useClipboardStore()
const { isAnyResourceCopied, project, canWriteToClipboard } = storeToRefs(clipboardStore)

function isProjectOption(option: typeof props.option): option is ProjectOption {
  return option.type !== 'group'
}

const icon = computed(() => {
  const valueRegExp = new RegExp(`^(recent-)?${project.value?.id}$`)
  return isAnyResourceCopied.value && valueRegExp.test(`${props.option.value}`) ? 'i-ic-outline-library-add-check' : 'i-ic-baseline-content-copy'
})
</script>

<template>
  <div class="flex items-center justify-between group/option space-x-2">
    <NTooltip>
      <template #trigger>
        <span class="truncate shrink">{{ option.label }}</span>
      </template>
      {{ option.label }}
    </NTooltip>
    <NTooltip v-if="isProjectOption(option)">
      <template #trigger>
        <NButton
          size="small"
          quaternary
          class="opacity-40 group-hover/option:opacity-100 copy-button"
          :disabled="!canWriteToClipboard"
          @click.stop="clipboardStore.copyProject(option.project)"
        >
          <template #icon>
            <UIcon :name="icon" />
          </template>
        </NButton>
      </template>
      <span v-if="canWriteToClipboard">Projekt kopieren</span>
      <span v-else>{{ copyFeatureNotSupportedHint }}</span>
    </NTooltip>
  </div>
</template>
